/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerProgramDto } from '../models/EntityModelResponseContainerProgramDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramControllerService {
    /**
     * @returns EntityModelResponseContainerProgramDto OK
     * @throws ApiError
     */
    public static read(): CancelablePromise<EntityModelResponseContainerProgramDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program',
        });
    }
}
